var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
    fill: "#D2D3D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16.2761 8 16.5 8.22386 16.5 8.5V15.5H23.5C23.7761 15.5 24 15.7239 24 16C24 16.2761 23.7761 16.5 23.5 16.5H16.5V23.5C16.5 23.7761 16.2761 24 16 24C15.7239 24 15.5 23.7761 15.5 23.5V16.5H8.5C8.22386 16.5 8 16.2761 8 16C8 15.7239 8.22386 15.5 8.5 15.5H15.5V8.5C15.5 8.22386 15.7239 8 16 8Z",
    fill: "#A0A1A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDisabled);
export default __webpack_public_path__ + "static/media/addDisabled.14091205d19d8ca587d03a5f98420bf7.svg";
export { ForwardRef as ReactComponent };